import {
  CHECK_COMMENTS_COUNT,
  SUBMIT_FEEDBACK,
} from './actionTypes';

const initialState = {
  notifications_page: 0,
};

export default function notifications(state = initialState, action) {
  switch(action.type) {
    case CHECK_COMMENTS_COUNT:
      return {...state, ...action.payload};
    case SUBMIT_FEEDBACK:
      let submittedState = {...state};
      submittedState[action.payload.kind] = submittedState[action.payload.kind] + 1;
      return {...state, submittedState};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/feedbacks/reducers.js